export default __webpack_public_path__ + "static/media/13-1.df9a2c82.jpg";